import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import { IState } from '../types';

export const state: () => Partial<IState> = () => ({
  environment: null,
  version: '',
  courseName: '',
  courseCover: '',
  courseDescription: '',
  authingId: '',
  isFestival: '',
  isPublic: 0, // 是否是公开链接
  userInfo: {
    avator: '',
    nickname: '',
    phone: '',
    id: '',
    email: ''
  },
  menuActive: false,
  context: {},
  project: {},
  portalSequence: [],
  portalMessage: {
    animation: false
  },
  score: {
    status: '',
    type: 'single',
    visible: false,
    value: 0,
    totalValue: 0,
    totalScoreVisible: false,
    selection_id: '',
    duration: 0,
    multipleValue: new Map()
  },
  callStatus: {
    isroll: true,
    rollHeight: undefined
  },
  survey: {
    toEnerValue: ''
  },
  // 兼容历史本地存储使用
  isLocalHistory: false,
  loading: false,
  practiceCourt: {
    visible: false,
    type: '',
    iframeUrl: '',
    userId: '',
    label: '',
    title: '',
    protocol: '',
    command: '',
    practiceCourtId: '',
    practiceCourtKind: ''
  },
  // 笔记相关
  note: {
    currentCheckId: '',
    currentCheckIndex: -1
  },
  surveyRecord: [],
  disalbeCopy: false,
  watermark: false,
  setyleNavHeight: 0,
  clewordNavVisible: false,

  // 完课回看功能使用
  isLookBack: false,

  // 手机号等授权信息
  auth: {
    phone: {
      status: '',
      value: ''
    }
  },

  // 绑定
  bind: {
    phone: {
      status: '',
      value: ''
    }
  },

  // 全局配置，隐藏回看菜单等
  globalConfig: null,

  // 摄像头配置
  isCameraOn: false
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
